import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartpocket/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/smartpocket/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartpocket/src/components/analytics/TrackedAnalyticsLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartpocket/src/components/seo/StructuredDataScripts.tsx");
